// var ol = omjs.ol;

/* 
    line_width
    line_color
    line_border_width
    line_border_color
    line_border_style
*/

var toRGBAstring = function(array) {
    return 'rgba('+ array.join(',') +')';
};

module.exports = function(style, zindex, scale) {
    // кружок для рисования
    var circle = new ol.style.Circle({
        radius: style['line_width'] / 2, // сомнительное решение. Скорее всего нужно будет убирать деление когда будет редактирование геометрии
        fill  : new ol.style.Fill({
            color: style['line_color']
        }),
        stroke: new ol.style.Stroke({
            color: style['line_border_color'],
            width: style['line_border_width'],
            // lineDash: style['line_border_style']
        })
    });

    /* обычный стиль */
    // стиль пунктира умножается на толщину линии чтобы линия смотрелась 
    // такой же как и на превью выбора пунктира. Если этого не делать, то
    // при слишком толстой линии пунктира не будет видно.
    var multiplied_dash = style['line_border_style'].map(function(v){
        return v * style['line_width'];
    });
    var regular = new ol.style.Style({
        stroke: new ol.style.Stroke({
            color: style['line_color'], // цвет линии
            width: style['line_width'], // толщина линии
            lineDash: multiplied_dash
        }),
        image : circle,
        zIndex: zindex
    });

    /* стиль для дополнительной обводки */
    // обводка умножается на 2 чтобы с каждой стороны линии было 
    // по style['line_border_width'] пикселей обводки. Толщина линии плюсуется
    // к толщине обводки потому что никаких обводок у линий нет и рисуются на 
    // самом деле 2 друг на друге.
    var stroke_width = style['line_width'] + (style['line_border_width'] * 2);
    var additional = new ol.style.Style({
        stroke: new ol.style.Stroke({
            color: style['line_border_color'],
            width: stroke_width,
            lineDash: multiplied_dash
        }),
        zIndex: zindex
    });

    return [additional, regular];
};



//////////////////
// WEBPACK FOOTER
// ./src/View/PublicMapDraw/line-style.js
// module id = 231
// module chunks = 0